import React, { useState } from "react";
import { AppListing } from "../../../../components/appListing";
import { carePlanApi } from "../../../../redux/service/careplan_service";
import MainPageDialog from "../../../../components/mainPageDialog";
import moment from "moment";
import BP from "../../../../assests/images/blood_pressure.png";
import BO from "../../../../assests/images/icon-blood_oxygen.png";
import RT from "../../../../assests/images/icon-respiratory_rate.png";
import Sleep from "../../../../assests/images/icon-sleep.png";
import Weight from "../../../../assests/images/icon-weight.png";
import Glucose from "../../../../assests/images/glucose-meter.png";
import HeartRate from "../../../../assests/images/heart-rate-monitor.png";
import Water from "../../../../assests/images/hydration.png";
import BodyTemperature from "../../../../assests/images/temperature.png";
import RespiratoryAmplitude from "../../../../assests/images/breathing.png";
import InspirationExpirationRatio from "../../../../assests/images/respiration.png";

const CareplanTrackers = ({ listData = [], loading = false }) => {
  const [trackerHistoryTrigger] =
    carePlanApi.endpoints.getTrackerHistory.useLazyQuery();

  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [trackerHistoryData, setTrackerHistoryData] = useState([]);

  const handleTrackerHistory = (item) => {
    setShowHistoryDialog(true);
    trackerHistoryTrigger({ tracker_id: item?.tracker_id }).then((response) => {
      setTrackerHistoryData(response?.data);
    });
  };

  const getImage = (name) => {
    switch (name) {
      case "Blood Pressure":
        return BP;
      case "Blood Oxygen":
        return BO;
      case "Respiratory Rate":
        return RT;
      case "Sleep":
        return Sleep;
      case "Weight":
        return Weight;
      case "Glucose":
        return Glucose;
      case "Heart Rate":
        return HeartRate;
      case "Water":
        return Water;
      case "Body Temperature":
        return BodyTemperature;
      case "Respiratory Amplitude":
        return RespiratoryAmplitude;
      case "Inspiration Expiration Ratio":
        return InspirationExpirationRatio;
      default:
        return "";
    }
  };

  const trackersCols = [
    { title: "Trackers", key: "formated_name",
      getData: (item) =>
        item?.formated_name ? (
          <span className="text-black text-sm flex flex-row gap-x-2">
            <img src={getImage(item?.formated_name)} className={`w-[22px] h-[22px]`} alt={item?.formated_name} />
            {item?.formated_name}
          </span>
        ) : (
          "-"
        ),
    },
    {
      title: "Last Value",
      key: "latest_logged_value",
      getData: (item) =>
        item?.latest_logged_value?.value ? (
          <div>
            {item?.latest_logged_value?.value[0]?.value}
            {item?.latest_logged_value?.value[1]?.value &&
              `/ ${item?.latest_logged_value?.value[1]?.value}`}{" "}
            {item?.latest_logged_value?.value[0]?.unit}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Date/time",
      key: "latest_logged_value",
      getData: (data) => {
        const originalDate =
          data?.latest_logged_value?.created !== ""
            ? moment(data?.latest_logged_value?.created).format("l")
            : "";
        return originalDate;
      },
    },
    {
      title: "Ranges & Frequency",
      key: "frequency",
      getData: (item) =>
        item?.frequency ? (
          <div>
            {item?.frequency?.type} {item?.frequency?.time.replace(/~/g, " ")}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "History",
      key: "history",
      colClass: "col-md-1 text-center",
      getData: () => (
        <div className="flex w-[100%] items-start justify-start px-2 text-blue-500 cursor-pointer hover:underline">
          View
        </div>
      ),
      onClick: (item) => handleTrackerHistory(item),
    },
  ];

  return (
    <>
      <div className="py-2">
        <AppListing
          loading={loading}
          listData={listData}
          cols={trackersCols}
        />
      </div>
      {showHistoryDialog && (
        <MainPageDialog
          title={trackerHistoryData[0]?.observation_formated_name}
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => setShowHistoryDialog(false),
            },
          ]}
          onCancelHandler={() => setShowHistoryDialog(false)}
        >
          <div className="px-3 py-5 text-left text-sm text-gray-900">
            {trackerHistoryData?.map((v) => {
              return (
                <div>
                  <p className="border-b-2 border-gray-500 py-5 ...">
                    {v.value?.map((val) => (
                      <p className="flex flex-col gap-y-3">
                        <span>
                          {val?.value} {val?.unit}
                        </span>
                        <span>{moment(val?.datetime).format("l hh:mm A")}</span>
                      </p>
                    ))}
                  </p>
                </div>
              );
            })}
          </div>
        </MainPageDialog>
      )}
    </>
  );
};

export default CareplanTrackers;
